import { render } from "./NewsListSlider.vue?vue&type=template&id=b001f6ca"
import script from "./NewsListSlider.vue?vue&type=script&lang=js"
export * from "./NewsListSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__